module.exports = __webpack_public_path__ + "img/img4.9393647f.jpg";